/* eslint-disable no-unused-vars */
import { lazy } from 'react'
import { typeUser, devMode } from '../localStorage'
import EditJobOffer from '../pages/JobOffers/components/EditJobOffer'
import {
  IS_ADMIN,
  IS_HIRING_ADVISOR,
  TYPE_OF_AUTH,
  TYPE_OF_USER,
} from '../utils/constants'
import CompanyDetail from '../pages/Company/components/CompanyDetail.js'
import Vacancies from '../pages/Vacancies/Vacancies.js'
import Tickets from '../pages/Admin/Tickets/Tickets.js'
import HutritNext from '../pages/Landing/SubLandings/HutritNext/HutritNext.js'
import Talents from '../pages/Talents/index.js'
import CreateJobOfferByJuniors from '../pages/JobOffers/components/CreateJobOfferByJuniors.js'
import FastHutritNextCompany from '../pages/Landing/SubLandings/FastHutritNextCompany/FastHutritNextCompany.js'
import ListFastOffersHutritNext from '../pages/Dashboard/NestedPages/ListFastOffersHutritNext.js'
import EditJobOfferHutritNext from '../pages/JobOffers/components/EditJobOfferHutritNext.js'
import UploadVideoTalent from '../pages/HutritClub/UploadVideoTalent/UploadVideoTalent.js'
import MasterClass from '../pages/HutritClub/MasterClass/MasterClass.js'
import MasterModule from '../pages/HutritClub/MasterModule/MasterModule.js'
import PublicModule from '../pages/HutritClub/PublicModule/PublicModule.js'
import PublicTalentDetail from '../pages/HutritClub/PublicModule/components/PublicTalentDetail.js'
import ListOfChallenges from '../pages/HutritClub/ListOfChallenges/ListOfChallenges.js'
import CreateChallenge from '../pages/HutritClub/CreateChallenge/CreateChallenge.js'
import ChallengeDetail from '../pages/HutritClub/ListOfChallenges/components/ChallengeDetail.js'
import EditJobOfferByJuniors from '../pages/JobOffers/components/EditJobOfferByJuniors.js'
import UploadPdfTalentByTm from '../pages/TmTalents/components/UploadPdfTalentByTm.js'
import DevDashboard from '../pages/DevDashboard/DevDashboard.js'
import CreateNewFastCompany from '../pages/Admin/CreateNewFastCompany.js'
import Accounting from '../pages/Accounting/Accounting.js'
import Billing from '../pages/Billing/Billing.js'
import CompanyBilling from '../pages/Billing/CompanyBilling.js'
import CompanyInvoiceDetail from '../pages/Billing/CompanyInvoiceDetail.js'
import CompanyContract from '../pages/CompanyContract/CompanyContract.js'
import ContractSigning from '../pages/ContractSigning/ContractSigning.js'
import TalentContractSigning from '../pages/TalentContract/TalentContractSigning.js'
import CustomPrompts from '../pages/Admin/CustomPrompts/CustomPrompts.js'
import AdminMasterClasses from '../pages/Admin/MasterClasses/MasterClasses.js'
import FormTypes from '../pages/Admin/FormTypes/FormTypes.js'
import RegisterFlags from '../pages/Admin/RegisterFlags/RegisterFlags.js'
import WhatsappMaster from '../pages/Admin/WhatsappMaster/WhatsappMaster.js'
import ContractDocuments from '../pages/Admin/ContractDocuments/ContractDocuments.js'
import ContractDocumentDetail from '../pages/Admin/ContractDocuments/ContractDocumentDetail.js'
import Courses from '../pages/Admin/Courses/Courses.js'
import CourseDetail from '../pages/Admin/Courses/CourseDetail.js'
import CourseQuestions from '../pages/Admin/Courses/CourseQuestions.js'
import ExamTracking from '../pages/Admin/Courses/ExamTracking.js'
import LandingHutrit from '../pages/Landing/LandingHutrit.js'
import VerifyAccount from '../pages/VerifyAccount/VerifyAccount.js'

// const NotificationSetting = lazy(() =>
//   import('../pages/Setting/components/NotificationSetting.js')
// )

const UpdateCompanyInformation = lazy(() =>
  import('../pages/UpdateCompanyInformation/UpdateCompanyInformation')
)

//const TmCompanies = lazy(() => import('../pages/TmCompanies/TmCompanies.js'))

const SuperSearch = lazy(() => import('../pages/SuperSearch/SuperSearch.js'))

const HiringAdvisorAI = lazy(() =>
  import('../pages/HiringAdvisorAI/HiringAdvisorAI.js')
)

const HiringAdvisorAIDeepSeek = lazy(() =>
  import('../pages/HiringAdvisorAI/HiringAdvisorAIDeepSeek.js')
)

const CompleteRegister = lazy(() =>
  import('../pages/CompleteRegister/CompleteRegister.js')
)

const CompanyPersonalInformation = lazy(() =>
  import('../pages/CompanyPersonalInformation/CompanyPersonalInformation.js')
)

const ListOfSoftSkills = lazy(() =>
  import('../pages/Admin/ListOfSoftSkills/ListOfSoftSkills.js')
)

const ActiveProcesses = lazy(() =>
  import('../pages/ActiveProcesses/ActiveProcesses.js')
)

const TmTalents = lazy(() => import('../pages/TmTalents/TmTalents.js'))

// const TmJobOffersReceived = lazy(() =>
//   import('../pages/TmJobOffers/TmJobOffersReceived.js')
// )

const FrecuentQuestions = lazy(() =>
  import('../pages/FrecuentQuestions/FrecuentQuestions.js')
)

const DashboardTalentsManagers = lazy(() =>
  import('../pages/Admin/dashboard/DashboardTalentsManagers')
)

const TalentsAsociateTm = lazy(() =>
  import('../pages/TalentsAsociateTm/TalentsAsociateTm')
)

const HiringAdvisorDetailFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/HiringAdvisorDetailFromAdmin')
)

const CreateHiringAdvisor = lazy(() =>
  import('../pages/Admin/CreateHiringAdvisor')
)
const ListOfHiringAdvisor = lazy(() =>
  import('../pages/Admin/ListOfHiringAdvisor')
)
const AllNotifications = lazy(() =>
  import('../pages/AllNotifications/AllNotifications')
)
const Candidates = lazy(() => import('../pages/Candidates/Candidates'))
const ChangePassword = lazy(() => import('../pages/ChangePassword'))

const CompanyInformation = lazy(() =>
  import('../pages/CompanyInformation/CompanyInformation')
)

const Dashboard = lazy(() => import('../pages/Dashboard/Dashboard'))

const AllOffersFromRecruiter = lazy(() =>
  import('../pages/Dashboard/NestedPages/AllOffersFromRecruiter')
)
const ChangeEmail = lazy(() =>
  import('../pages/Dashboard/NestedPages/ChangeEmail')
)
const CompaniesFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/CompaniesFromAdmin')
)
const CompanyDetailFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/CompanyDetailFromAdmin')
)
const IncompleteProfiles = lazy(() =>
  import('../pages/Dashboard/NestedPages/IncompleteProfiles')
)
const ListOfCategories = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfCategories')
)
const ListOfCities = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfCities')
)
const ListOfIdioms = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfIdioms')
)
const ListOfSectors = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfSectors')
)
const ListOfSkills = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfSkills')
)
const ListOfStates = lazy(() =>
  import('../pages/Dashboard/NestedPages/ListOfStates')
)
const RecruiterDetailFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/RecruiterDetailFromAdmin')
)
const RecruiterNetwork = lazy(() =>
  import('../pages/Dashboard/NestedPages/RecruiterNetwork')
)
const RecruiterTalentDetail = lazy(() =>
  import('../pages/Dashboard/NestedPages/RecruiterTalentDetail')
)
const RecruitersFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/RecruitersFromAdmin')
)
const SendEmails = lazy(() =>
  import('../pages/Dashboard/NestedPages/SendEmails')
)
const TalentsFromAdmin = lazy(() =>
  import('../pages/Dashboard/NestedPages/TalentsFromAdmin')
)
const ForgetPassword = lazy(() => import('../pages/ForgetPassword'))
const CompanieDetailByHiringAdvisor = lazy(() =>
  import('../pages/HiringAdvisor/CompanieDetailByHiringAdvisor')
)
const ListOfCompaniesByHiringAdvisor = lazy(() =>
  import('../pages/HiringAdvisor/ListOfCompaniesByHiringAdvisor')
)
const MyListOfJobOffers = lazy(() =>
  import('../pages/HiringAdvisor/components/MyListOfJobOffers')
)
const ListOfFastOffers = lazy(() =>
  import('../pages/JobOffers/ListOfFastOffers')
)
const ListOfJobOffers = lazy(() => import('../pages/JobOffers/ListOfJobOffers'))
const CreateJobOffer = lazy(() =>
  import('../pages/JobOffers/components/CreateJobOffer')
)
const FastOfferDetail = lazy(() =>
  import('../pages/JobOffers/components/FastOfferDetail')
)
const JobOfferDetail = lazy(() =>
  import('../pages/JobOffers/components/JobOfferDetail')
)
const Login = lazy(() => import('../pages/Login/Login'))
const MyProfile = lazy(() => import('../pages/MyProfile/MyProfile'))
const MyResume = lazy(() => import('../pages/MyResume/MyResume'))
const NewPersonalInformation = lazy(() =>
  import('../pages/NewPersonalInformation/NewPersonalInformation')
)
const OrderCompanies = lazy(() =>
  import('../pages/OrderCompanies/OrderCompanies')
)
const PersonalInformation = lazy(() =>
  import('../pages/PersonalInformation/PersonalInformation')
)
const Process = lazy(() => import('../pages/Process/Process'))
const ProfessionalInformation = lazy(() =>
  import('../pages/ProfessionalInformation')
)
const RecoveryPassword = lazy(() => import('../pages/RecoveryPassword'))
const Register = lazy(() => import('../pages/Register/Register'))
const VerificationEmailMessage = lazy(() =>
  import('../pages/Register/components/VerificationEmailMessage')
)
const VerifyEmailUser = lazy(() =>
  import('../pages/Register/components/VerifyEmailUser')
)

const Setting = lazy(() => import('../pages/Setting/Setting'))
const TalentInformation = lazy(() =>
  import('../pages/TalentInformation/TalentInformation')
)
const TalentDetail = lazy(() =>
  import('../pages/Talents/components/TalentDetail')
)
const TermsAndConditions = lazy(() =>
  import('../pages/TermsAndConditions/TermsAndConditions')
)
const ListOfTalentsMatch = lazy(() =>
  import('../pages/HiringAdvisor/components/ListOfTalentsMatch')
)

const EmailConfigForm = lazy(() =>
  import('../pages/HiringAdvisor/EmailConfigForm/EmailConfigForm')
)

const QuickOffer = lazy(() =>
  import('../pages/Landing/components/QuickOffer.js')
)
const ChatWhatsapp = lazy(() => import('../pages/ChatWhatsapp/ChatWhatsapp.js'))
const QuickOfferMaster = lazy(() => import('../pages/Admin/QuickOffer'))

const Academy = lazy(() => import('../pages/Academy/Academy.js'))

// simple routes

export const PRIVATE_ROUTES = {
  contactUs: '/contact-us',
  talents: '/talents',
  talents_juniors: '/talents-juniors',
  talent_detail: '/talent/:id',
  talent_detail_juniors: '/talent-juniors/:id',
  talent_detail_by_job_offer: '/talent/:id/:idJobOffer/:idProcess',
  dashboard: '/dashboard',
  invite_talent: '/invite_talent',
  incomplete_profiles: '/incomplete-profiles',
  process: '/process',
  process_detail: '/process/:id/:idJobOffer',
  my_resume: '/my-resume',
  my_profile: '/my-profile',
  my_curriculum: '/my-curriculum',
  personal_data: '/personal-data',
  professional_data: '/professional-data',
  update_works_data: '/update-works-data',
  change_password: '/change-password',
  my_favorites: '/my-favorites',
  offer_management: '/offer-management',
  offer_management_detail: IS_ADMIN
    ? '/offer-management/:offerManagementId/:id'
    : '/offer-management/:offerManagementId',
  download_offer_view: '/download-offer-view/:offerManagementId',
  recruiter_network: '/recruiter-network',
  recruiter_talent_detail: '/recruiter-talent-detail/:id',
  recruiter_talent_detail_by_processes_actives:
    '/recruiter-talent-detail-by-processes-actives/:id',
  recruiter_talent_detail_by_offers_received:
    '/recruiter-talent-detail-by-offers-received/:id',
  all_offers_from_recruiter: '/all-offers-from-recruiter',
  offers_sent: '/offers-sent',
  company_detail: '/company-detail/:id',
  company_detail_ha: '/company-detail/:id',
  complete_profiles: '/complete-profiles',
  change_email: '/change-email',
  all_notifications: '/all-notifications',
  talent_information: '/talent-information',
  update_personal_information: '/update-personal-information',
  update_professional_information: '/update-professional-information',
  company_form: '/company-form',
  list_of_offers: '/list-of-offers',
  list_of_offers_juniors: '/list-of-offers-juniors',
  create_job_offer: '/create-job-offer',
  create_job_offer_juniors: '/create-job-offer-juniors',
  create_job_offer_juniors_asociate_id: '/create-job-offer-juniors/:id',
  create_job_offer_asociate_id: '/create-job-offer/:id',
  candidates:
    IS_HIRING_ADVISOR || IS_ADMIN
      ? '/candidates/:id/:idCompany'
      : '/candidates/:id',
  hiring_advisor_ai: '/hiring-advisor-ai',
  hiring_advisor_ai_deepseek: '/hiring-advisor-ai-deepseek',
  list_of_companies_by_hiring_advisor: '/list-of-companies-by-hiring-advisor',
  list_of_offers_company_ha: '/list-of-offers/:companyId',
  company_detail_by_hiring_advisor: '/company-detail-by-hiring-advisor/:id',
  setting: '/setting',
  chatgpt_assistant: '/chatgpt-assistant',
  list_of_fast_offers_by_ha: '/list-of-fast-offers-by-ha',
  edit_job_offer: '/edit-job-offer/:id',
  edit_job_offer_juniors: '/edit-job-offer-juniors/:id',
  offers_with_talents_tm: '/offers-with-talents-tm',
  update_company_information: '/update-company-information',
  frecuent_questions: '/frecuent-questions',
  tm_talents: '/tm-talents',
  tm_job_offers_received: '/talent-manager-job-offers-received',
  active_processes: '/active-processes',
  tm_companies: '/tm-companies',
  company_personal_information: '/company-personal-information',
  update_talent_information: '/update-talent-information',
  notification_setting: '/notification-setting',
  suscriptions: '/suscriptions',
  offer_juniors_detail: '/offer-juniors-detail/:offerManagementId',
  hutrit_club_upload_video: '/hutrit-club-upload-video',
  hutrit_club_talent_detail: '/hutrit-club-talent-detail-video/:id',
  list_of_challenges: '/list-of-challenges',
  create_challenge: '/create-challenge',
  challenge_detail: '/challenge-detail/:id',
  master_class: '/master-class',
  masterClass: '/master-classes',
  academy: '/academy',
  upload_talent_pdf_by_tm: '/upload-talent-pdf-by-tm',

  // --> COMPANY BILLING
  company_billing: '/mis-facturas',
  company_billing_detail: '/mis-facturas/:id',
  company_contract: '/mi-contrato',
  contract_signing: '/firma-contrato',

  // --> TALENT CONTRACT
  talent_contract: '/mi-contrato-talento',

  // --> ADMIN ROUTES
  admin_accounting: '/admin-accounting/:companyId',
  admin_billing: '/admin-billing/:companyId',
  admin_talents: '/admin-talents',
  admin_recruiters: '/admin-recruiters',
  admin_recruiters_detail: '/admin-recruiters/:id',
  admin_companies: '/admin-companies',
  admin_companies_detail: '/admin-companies-detail/:id',
  admin_send_emails: '/admin-send-emails',
  list_Of_Skills: '/list-Of-Skills',
  list_of_soft_skills: '/list-of-soft-skills',
  list_Of_Sectors: '/list-Of-Sectors',
  list_Of_Categories: '/list-Of-Categories',
  list_of_city: '/list-of-city',
  list_of_idioms: '/list-of-idioms',
  list_of_fast_offers: '/list-of-fast-offers',
  fast_offer_detail: '/fast-offer-detail/:id',
  list_of_order_companies: '/list-of-order-companies',
  list_of_validate_fast_offers: '/list-of-validate-fast-offers',
  fast_validate_offer_detail: '/fast-validate-offer-detail/:id',
  list_of_states: '/list-of-states',
  create_hiring_advisor: '/create-hiring-advisor',
  list_of_hiring_advisors: '/list-of-hiring-advisors',
  register_recruiter: '/register-recruiter',
  list_of_talents_match: '/list-of-talents-match/:id',
  hiring_advisor_detail: '/hiring-advisor/:id',
  ha_email_config: '/ha-email-config',
  admin_quick_offer: '/admin-quick-offer',
  dashboard_talents_managers: '/dashboard-talents-managers',
  master_talent_detail: '/master-talent-detail/:id',

  offer_detail_admin: '/offer-detail-admin/:offerManagementId',
  register_by_complete_company: '/register-by-complete-company',
  hutrit_next: '/hutrit-next',
  tickets: '/tickets',
  list_fast_offers_hutrit_next: '/list-fast-offers-hutrit-next',
  list_of_video_talents_master: '/list-of-video-talents',
  dev_dashboard: '/dev-dashboard',
  create_new_fast_company: '/create-new-fast-company',
  chat_whatsapp: '/chat-whatsapp',
  custom_prompts: '/custom-prompts',
  admin_master_classes: '/admin-master-classes',
  form_types: '/form-types',
  register_flags: '/register-flags',
  admin_webinars: '/admin-webinars',
  whatsapp_master: '/whatsapp-master',
  master_contract_documents: '/master-contracts',
  master_contract_document_detail: '/master-contracts/:id',
  master_courses: '/master-courses',
  master_course_detail: '/master-courses/:id',
  master_course_questions: '/master-courses/:id/questions',
  master_exam_tracking: '/master-courses-exam-tracking',
}

export const PUBLIC_ROUTES = {
  home: '/',
  landing_talent: '/landing-talent',
  landing_partners: '/landing_partners',
  landing_hutrit_next: '/landing-hutrit-next',
  login: '/login',
  login_token: '/login/:code',
  login_company: '/login/company/:companyToken',
  about: '/about',
  register: '/register',
  register_company: '/register-company',
  register_company_hutrit_next: '/register-company-hutrit-next',
  register_talent: '/register-talent',
  register_talent_hutrit_next:
    '/tm-link/:invitationCode/:idiom/hutrit-club-link',
  register_talent_by_vacancies_link:
    '/register-talent-by-vacancies-link/:invitationCode',
  register_by_company: '/register-by-company',
  register_by_company_by_code: '/register-by-company/:code',
  verify_email_user: '/verify-email-user/:token',
  verify_email_user_by_company: '/verify-email-user/company/:token',
  register_by_inivitation_code: '/tm-link/:invitationCode/:idiom',
  register_by_inivitation_code_without_idiom: '/tm-link/:invitationCode',
  register_by_external_register: '/register/:offerName',
  forget_password: '/forget-password',
  recovery_pasword: '/recovery-password/:token',
  public_talent_detail: '/public-talents/:id',
  terms_and_conditions: '/termns-and-conditions',
  create_fast_job_offer: '/create-fast-job-offer/:token',
  create_fast_job_offer_by_ha: '/create-fast-job-offer/ha/:code',
  go_to_email: '/go-to-email',
  contact_us: '/contact-us',
  quick_offer: '/quick-offer',
  quick_offer_24hrs: '/quick-offer-24hrs',
  landing_by_tm_company_code: '/tm-company-code/:code',
  super_search: '/super-search/:code',
  super_search_static: '/super-search',
  company_activation: '/company-activation/:token',
  complete_register_google: '/complete-register-google/:token/:typeOfRegister',
  complete_register_google_invitation_code:
    '/complete-register-google/:token/:typeOfRegister/:invitationCode',
  complete_register_linkedin:
    '/complete-register-linkedin/:token/:typeOfRegister',
  complete_register_linkedin_invitation_code:
    '/complete-register-linkedin/:token/:typeOfRegister/:invitationCode',
  new_landing: '/new-landing',
  list_of_public_vacancies:
    '/list-of-public-vacancies/:offerManagementId/:invitationCode',
  hutrit_next_talent: '/hutrit-next-talent',
  fast_hutrit_next_company: '/fast-hutrit-next-company',
  hutrit_club_videos: '/hutrit-club-videos',
  hutrit_club_talent_detail: '/hutrit-club-talent-detail/:id',
  verify_account: '/verify-account/:token',
}

export const ADMIN_ROUTES = [
  {
    path: PRIVATE_ROUTES.admin_talents,
    element: <TalentsFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.admin_recruiters,
    element: <RecruitersFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.admin_recruiters_detail,
    element: <RecruiterDetailFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.admin_companies,
    element: <CompaniesFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.admin_companies_detail,
    element: <CompanyDetailFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.admin_send_emails,
    element: <SendEmails />,
  },
  {
    path: PRIVATE_ROUTES.list_Of_Skills,
    element: <ListOfSkills />,
  },
  {
    path: PRIVATE_ROUTES.list_of_soft_skills,
    element: <ListOfSoftSkills />,
  },
  {
    path: PRIVATE_ROUTES.list_Of_Categories,
    element: <ListOfCategories />,
  },
  {
    path: PRIVATE_ROUTES.list_Of_Sectors,
    element: <ListOfSectors />,
  },
  {
    path: PRIVATE_ROUTES.list_of_city,
    element: <ListOfCities />,
  },
  {
    path: PRIVATE_ROUTES.list_of_idioms,
    element: <ListOfIdioms />,
  },
  {
    path: PRIVATE_ROUTES.list_of_fast_offers,
    element: <ListOfFastOffers />,
  },
  {
    path: PRIVATE_ROUTES.fast_offer_detail,
    element: <FastOfferDetail />,
  },
  {
    path: PRIVATE_ROUTES.list_of_order_companies,
    element: <OrderCompanies />,
  },
  {
    path: PRIVATE_ROUTES.list_of_states,
    element: <ListOfStates />,
  },
  {
    path: PRIVATE_ROUTES.fast_validate_offer_detail,
    element: <FastOfferDetail validate />,
  },
  {
    path: PRIVATE_ROUTES.create_hiring_advisor,
    element: <CreateHiringAdvisor />,
  },
  {
    path: PRIVATE_ROUTES.list_of_hiring_advisors,
    element: <ListOfHiringAdvisor />,
  },
  {
    path: PRIVATE_ROUTES.register_recruiter,
    element: <Register isRecruiter />,
  },
  {
    path: PRIVATE_ROUTES.hiring_advisor_detail,
    element: <HiringAdvisorDetailFromAdmin />,
  },
  {
    path: PRIVATE_ROUTES.list_of_talents_match,
    element: <ListOfTalentsMatch />,
  },
  {
    path: PRIVATE_ROUTES.company_detail_by_hiring_advisor,
    element: <CompanieDetailByHiringAdvisor />,
  },
  {
    path: PRIVATE_ROUTES.admin_quick_offer,
    element: <QuickOfferMaster />,
  },
  {
    path: PRIVATE_ROUTES.tickets,
    element: <Tickets />,
  },
  {
    path: PRIVATE_ROUTES.dashboard_talents_managers,
    element: <DashboardTalentsManagers />,
  },
  {
    path: PRIVATE_ROUTES.dashboard_talents_managers,
    element: <DashboardTalentsManagers />,
  },
  {
    path: PRIVATE_ROUTES.master_talent_detail,
    element: <RecruiterTalentDetail isMaster />,
  },
  {
    path: PRIVATE_ROUTES.offer_detail_admin,
    element: <JobOfferDetail />,
  },
  {
    path: PRIVATE_ROUTES.register_by_complete_company,
    element: <Register isCompleteCompany />,
  },
  {
    path: PRIVATE_ROUTES.list_fast_offers_hutrit_next,
    element: <ListFastOffersHutritNext />,
  },
  {
    path: PRIVATE_ROUTES.list_of_video_talents_master,
    element: <MasterModule />,
  },
  {
    path: PRIVATE_ROUTES.hutrit_club_talent_detail,
    element: <PublicTalentDetail />,
  },
  {
    path: PRIVATE_ROUTES.create_new_fast_company,
    element: <CreateNewFastCompany />,
  },
  {
    path: `${PRIVATE_ROUTES.create_new_fast_company}/:id`,
    element: <CreateNewFastCompany />,
  },
  {
    path: PRIVATE_ROUTES.admin_accounting,
    element: <Accounting />,
  },
  {
    path: PRIVATE_ROUTES.admin_billing,
    element: <Billing />,
  },
  {
    path: PRIVATE_ROUTES.custom_prompts,
    element: <CustomPrompts />,
  },
  {
    path: PRIVATE_ROUTES.admin_master_classes,
    element: <AdminMasterClasses />,
  },
  {
    path: PRIVATE_ROUTES.form_types,
    element: <FormTypes />,
  },
  {
    path: PRIVATE_ROUTES.register_flags,
    element: <RegisterFlags />,
  },
  {
    path: PRIVATE_ROUTES.whatsapp_master,
    element: <WhatsappMaster />,
  },
  {
    path: PRIVATE_ROUTES.master_contract_documents,
    element: <ContractDocuments />,
  },
  {
    path: PRIVATE_ROUTES.master_contract_document_detail,
    element: <ContractDocumentDetail />,
  },
  {
    path: PRIVATE_ROUTES.master_courses,
    element: <Courses />,
  },
  {
    path: PRIVATE_ROUTES.master_course_detail,
    element: <CourseDetail />,
  },
  {
    path: PRIVATE_ROUTES.master_course_questions,
    element: <CourseQuestions />,
  },
  {
    path: PRIVATE_ROUTES.master_exam_tracking,
    element: <ExamTracking />,
  },
]

export const COMPANY_ROUTES = [
  {
    path: PRIVATE_ROUTES.process_detail,
    element: <Process />,
  },
  {
    path: PRIVATE_ROUTES.edit_job_offer,
    element: <EditJobOffer />,
  },
  {
    path: PRIVATE_ROUTES.edit_job_offer_juniors,
    element: <EditJobOfferByJuniors />,
  },
  {
    path: PRIVATE_ROUTES.update_company_information,
    element: <UpdateCompanyInformation />,
  },
  {
    path: PRIVATE_ROUTES.company_personal_information,
    element: <CompanyPersonalInformation />,
  },
  {
    path: PRIVATE_ROUTES.talents_juniors,
    element: <Talents isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.list_of_video_talents_master,
    element: <PublicModule />,
  },
  {
    path: PRIVATE_ROUTES.hutrit_club_talent_detail,
    element: <PublicTalentDetail />,
  },
  {
    path: PRIVATE_ROUTES.list_of_challenges,
    element: <ListOfChallenges />,
  },
  {
    path: PRIVATE_ROUTES.create_challenge,
    element: <CreateChallenge />,
  },
  {
    path: PRIVATE_ROUTES.challenge_detail,
    element: <ChallengeDetail />,
  },
  {
    path: PRIVATE_ROUTES.company_contract,
    element: <CompanyContract />,
  },
  {
    path: PRIVATE_ROUTES.company_billing,
    element: <CompanyBilling />,
  },
  {
    path: PRIVATE_ROUTES.company_billing_detail,
    element: <CompanyInvoiceDetail />,
  },
  {
    path: PRIVATE_ROUTES.contract_signing,
    element: <ContractSigning />,
  },
  {
    path: PRIVATE_ROUTES.company_form,
    element: <CompanyInformation />,
  },
  // {
  //   path: PRIVATE_ROUTES.suscriptions,
  //   element: <Suscriptions />,
  // },
]

const TALENT_ROUTES = [
  {
    path: PRIVATE_ROUTES.update_talent_information,
    element: <TalentInformation isUpdate />,
  },
  {
    path: PRIVATE_ROUTES.talent_contract,
    element: <TalentContractSigning />,
  },
  {
    path: PRIVATE_ROUTES.hutrit_next,
    element: <HutritNext />,
  },
  {
    path: PRIVATE_ROUTES.hutrit_club_upload_video,
    element: <UploadVideoTalent />,
  },
  {
    path: PRIVATE_ROUTES.master_class,
    element: <UploadVideoTalent isMasterClass />,
  },
  {
    path: PRIVATE_ROUTES.masterClass,
    element: <MasterClass />,
  },
  {
    path: PRIVATE_ROUTES.academy,
    element: <Academy />,
  },
  // {
  //   path: PRIVATE_ROUTES.notification_setting,
  //   element: <NotificationSetting />,
  // },
]

const TM_ROUTES = [
  {
    path: PRIVATE_ROUTES.frecuent_questions,
    element: <FrecuentQuestions />,
  },
  {
    path: PRIVATE_ROUTES.tm_talents,
    element: <TmTalents />,
  },
  {
    path: PRIVATE_ROUTES.active_processes,
    element: <ActiveProcesses />,
  },
  {
    path: PRIVATE_ROUTES.upload_talent_pdf_by_tm,
    element: <UploadPdfTalentByTm />,
  },
  // {
  //   path: PRIVATE_ROUTES.tm_companies,
  //   element: <TmCompanies />,
  // },

  // {
  //   path: PRIVATE_ROUTES.tm_job_offers_received,
  //   element: <TmJobOffersReceived />,
  // },
]

const REST_OF_ROUTES = [
  {
    path: PRIVATE_ROUTES.change_email,
    element: <ChangeEmail />,
  },
  {
    path: PRIVATE_ROUTES.my_resume,
    element: <MyResume />,
  },
  {
    path: PRIVATE_ROUTES.my_profile,
    element: <MyProfile />,
  },
  {
    path: PRIVATE_ROUTES.personal_data,
    element: <PersonalInformation />,
  },
  {
    path: PRIVATE_ROUTES.incomplete_profiles,
    element: <IncompleteProfiles />,
  },
  {
    path: PRIVATE_ROUTES.recruiter_network,
    element: <RecruiterNetwork />,
  },
  {
    path: PRIVATE_ROUTES.all_offers_from_recruiter,
    element: <AllOffersFromRecruiter />,
  },
  {
    path: PRIVATE_ROUTES.incomplete_profiles,
    element: <IncompleteProfiles />,
  },
  {
    path: PRIVATE_ROUTES.complete_profiles,
    element: <RecruiterNetwork />,
  },
  {
    path: PRIVATE_ROUTES.create_job_offer,
    element: <CreateJobOffer />,
  },
  {
    path: PRIVATE_ROUTES.create_job_offer_juniors,
    element: <CreateJobOfferByJuniors />,
  },
  {
    path: PRIVATE_ROUTES.create_job_offer_juniors_asociate_id,
    element: <CreateJobOfferByJuniors />,
  },
  {
    path: PRIVATE_ROUTES.create_job_offer_asociate_id,
    element: <CreateJobOffer />,
  },
  {
    path: PRIVATE_ROUTES.offers_with_talents_tm,
    element: <TalentsAsociateTm />,
  },

  // talent routes

  {
    path: PRIVATE_ROUTES.talent_information,
    element: <TalentInformation />,
  },
  {
    path: PRIVATE_ROUTES.update_professional_information,
    element: <ProfessionalInformation />,
  },
  {
    path: PRIVATE_ROUTES.update_personal_information,
    element: <NewPersonalInformation />,
  },
  {
    path: PRIVATE_ROUTES.list_of_offers,
    element: <ListOfJobOffers />,
  },
  {
    path: PRIVATE_ROUTES.list_of_offers_juniors,
    element: <ListOfJobOffers isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.list_of_offers_company_ha,
    element: <ListOfJobOffers isFromHA />,
  },

  // general routes

  {
    path: PRIVATE_ROUTES.candidates,
    element: <Candidates />,
  },
  {
    path: PRIVATE_ROUTES.dashboard,
    element: <Dashboard />,
  },
  {
    path: PRIVATE_ROUTES.talent_detail,
    element: <TalentDetail />,
  },
  {
    path: PRIVATE_ROUTES.talent_detail_juniors,
    element: <TalentDetail isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.recruiter_talent_detail,
    element: <RecruiterTalentDetail isTm />,
  },
  {
    path: PRIVATE_ROUTES.recruiter_talent_detail_by_processes_actives,
    element: <RecruiterTalentDetail isProcessesActivesRoute />,
  },
  {
    path: PRIVATE_ROUTES.recruiter_talent_detail_by_offers_received,
    element: <RecruiterTalentDetail isOffersReceived />,
  },
  {
    path: PRIVATE_ROUTES.offer_management_detail,
    element: <JobOfferDetail />,
  },
  {
    path: PRIVATE_ROUTES.download_offer_view,
    element: <JobOfferDetail isDownloadOfferView />,
  },
  {
    path: PRIVATE_ROUTES.offer_juniors_detail,
    element: <JobOfferDetail isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.all_notifications,
    element: <AllNotifications />,
  },
  {
    path: PRIVATE_ROUTES.change_password,
    element: <ChangePassword />,
  },
  {
    path: PRIVATE_ROUTES.setting,
    element: <Setting />,
  },
  {
    path: PRIVATE_ROUTES.talent_detail_by_job_offer,
    element: <TalentDetail isProcessView />,
  },
  {
    path: PRIVATE_ROUTES.company_detail,
    element: <CompanyDetail />,
  },
]

const HIRING_ADVISOR_ROUTES = [
  {
    path: PRIVATE_ROUTES.hiring_advisor_ai,
    element: <HiringAdvisorAI />,
  },
  {
    path: PRIVATE_ROUTES.hiring_advisor_ai_deepseek,
    element: <HiringAdvisorAIDeepSeek />,
  },
  {
    path: PRIVATE_ROUTES.list_of_companies_by_hiring_advisor,
    element: <ListOfCompaniesByHiringAdvisor />,
  },
  {
    path: PRIVATE_ROUTES.create_new_fast_company,
    element: <CreateNewFastCompany />,
  },
  {
    path: `${PRIVATE_ROUTES.create_new_fast_company}/:id`,
    element: <CreateNewFastCompany />,
  },
  {
    path: PRIVATE_ROUTES.ha_email_config,
    element: <EmailConfigForm />,
  },
  {
    path: PRIVATE_ROUTES.company_detail_by_hiring_advisor,
    element: <CompanieDetailByHiringAdvisor />,
  },
  {
    path: PRIVATE_ROUTES.list_of_fast_offers_by_ha,
    element: <MyListOfJobOffers />,
  },
  {
    path: PRIVATE_ROUTES.list_of_talents_match,
    element: <ListOfTalentsMatch />,
  },
  {
    path: PRIVATE_ROUTES.process_detail,
    element: <Process />,
  },
  {
    path: PRIVATE_ROUTES.company_detail_ha,
    element: <CompanyDetail seeFromHA />,
  },
  // Juniors tab routes for Hiring Advisor
  {
    path: PRIVATE_ROUTES.talents_juniors,
    element: <Talents isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.list_of_video_talents_master,
    element: <PublicModule />,
  },
  {
    path: PRIVATE_ROUTES.hutrit_club_talent_detail,
    element: <PublicTalentDetail />,
  },
  {
    path: PRIVATE_ROUTES.list_of_challenges,
    element: <ListOfChallenges />,
  },
  {
    path: PRIVATE_ROUTES.create_challenge,
    element: <CreateChallenge />,
  },
  {
    path: PRIVATE_ROUTES.challenge_detail,
    element: <ChallengeDetail />,
  },
  {
    path: PRIVATE_ROUTES.list_of_offers_juniors,
    element: <ListOfJobOffers isJuniorView />,
  },
  {
    path: PRIVATE_ROUTES.edit_job_offer_juniors,
    element: <EditJobOfferByJuniors />,
  },
  {
    path: PRIVATE_ROUTES.chat_whatsapp,
    element: <ChatWhatsapp />,
  },
]

const DEV_ROUTES = devMode
  ? [
      {
        path: PRIVATE_ROUTES.dev_dashboard,
        element: <DevDashboard />,
      },
    ]
  : []

const renderUserRoutes = {
  [TYPE_OF_USER.out_off_the_app]: [...REST_OF_ROUTES, ...DEV_ROUTES],
  [TYPE_OF_USER.talent]: [...TALENT_ROUTES, ...REST_OF_ROUTES, ...DEV_ROUTES],
  [TYPE_OF_USER.recruiter]: [...TM_ROUTES, ...REST_OF_ROUTES, ...DEV_ROUTES],
  [TYPE_OF_USER.company]: [...COMPANY_ROUTES, ...REST_OF_ROUTES, ...DEV_ROUTES],
  [TYPE_OF_USER.hiring_advisor]: [
    ...HIRING_ADVISOR_ROUTES,
    ...REST_OF_ROUTES,
    ...DEV_ROUTES,
  ],
  [TYPE_OF_USER.admin]: [...ADMIN_ROUTES, ...REST_OF_ROUTES, ...DEV_ROUTES],
}

export const LIST_OF_PRIVATES_ROUTES = renderUserRoutes[typeUser] || []

export const LIST_OF_PUBLIC_ROUTES = [
  {
    path: PUBLIC_ROUTES.home,
    element: <LandingHutrit />,
  },
  {
    path: PUBLIC_ROUTES.forget_password,
    element: <ForgetPassword />,
  },
  {
    path: PUBLIC_ROUTES.register,
    element: <Register />,
  },
  {
    path: PUBLIC_ROUTES.register_company,
    element: <Register typeOfUser="company" />,
  },
  {
    path: PUBLIC_ROUTES.register_company_hutrit_next,
    element: <Register typeOfUser="company" isHutritNext />,
  },
  {
    path: PUBLIC_ROUTES.register_talent,
    element: <Register typeOfUser="talent" />,
  },
  {
    path: PUBLIC_ROUTES.register_talent_by_vacancies_link,
    element: <Register typeOfUser="talent" />,
  },
  {
    path: PUBLIC_ROUTES.register_talent_hutrit_next,
    element: <Register typeOfUser="talent" isHutritNext />,
  },
  {
    path: PUBLIC_ROUTES.register_by_inivitation_code,
    element: <Register typeOfUser="talent" />,
  },
  {
    path: PUBLIC_ROUTES.register_by_inivitation_code_without_idiom,
    element: <Register typeOfUser="talent" />,
  },
  {
    path: PUBLIC_ROUTES.register_by_inivitation_code_without_idiom,
    element: <Register typeOfUser="talent" />,
  },
  {
    path: PUBLIC_ROUTES.register_by_external_register,
    element: <Register typeOfUser="talent" externalRegister />,
  },
  {
    path: PUBLIC_ROUTES.login,
    element: <Login />,
  },
  {
    path: PUBLIC_ROUTES.login_token,
    element: <Login />,
  },
  {
    path: PUBLIC_ROUTES.login_company,
    element: <Login />,
  },
  {
    path: PUBLIC_ROUTES.verify_email_user,
    element: <VerifyEmailUser />,
  },
  {
    path: PUBLIC_ROUTES.verify_email_user_by_company,
    element: <VerifyEmailUser isCompany />,
  },
  {
    path: PUBLIC_ROUTES.recovery_pasword,
    element: <RecoveryPassword />,
  },
  {
    path: PUBLIC_ROUTES.public_talent_detail,
    element: <MyResume />,
  },
  {
    path: PUBLIC_ROUTES.go_to_email,
    element: (
      <VerificationEmailMessage
        email={JSON.parse(localStorage.getItem('currentEmail'))}
      />
    ),
  },
  {
    path: PUBLIC_ROUTES.terms_and_conditions,
    element: <TermsAndConditions />,
  },
  {
    path: PUBLIC_ROUTES.register_by_company,
    element: <Register isCompany />,
  },
  {
    path: PUBLIC_ROUTES.register_by_company_by_code,
    element: <Register typeOfUser="company" isCompany />,
  },
  {
    path: PUBLIC_ROUTES.quick_offer,
    element: <QuickOffer />,
  },
  {
    path: PUBLIC_ROUTES.quick_offer_24hrs,
    element: <QuickOffer is24hrs />,
  },
  {
    path: PUBLIC_ROUTES.landing_by_tm_company_code,
    element: <LandingHutrit />,
  },
  {
    path: PUBLIC_ROUTES.fast_hutrit_next_company,
    element: <FastHutritNextCompany />,
  },
  // {
  //   path: PUBLIC_ROUTES.super_search,
  //   element: <SuperSearch isSuperSearch />,
  // },
  {
    path: PUBLIC_ROUTES.super_search_static,
    element: <SuperSearch isSuperSearch />,
  },
  {
    path: PUBLIC_ROUTES.complete_register_google,
    element: <CompleteRegister typeOfAuth={TYPE_OF_AUTH.google} />,
  },
  {
    path: PUBLIC_ROUTES.complete_register_google_invitation_code,
    element: <CompleteRegister typeOfAuth={TYPE_OF_AUTH.google} />,
  },
  {
    path: PUBLIC_ROUTES.complete_register_linkedin,
    element: <CompleteRegister typeOfAuth={TYPE_OF_AUTH.linkedin} />,
  },
  {
    path: PUBLIC_ROUTES.complete_register_linkedin_invitation_code,
    element: <CompleteRegister typeOfAuth={TYPE_OF_AUTH.linkedin} />,
  },
  {
    path: PUBLIC_ROUTES.list_of_public_vacancies,
    element: <Vacancies />,
  },
  {
    path: PUBLIC_ROUTES.hutrit_next_talent,
    element: <HutritNext />,
  },
  {
    path: PUBLIC_ROUTES.hutrit_club_videos,
    element: <PublicModule />,
  },
  {
    path: PUBLIC_ROUTES.hutrit_club_talent_detail,
    element: <PublicTalentDetail />,
  },
  {
    path: PUBLIC_ROUTES.verify_account,
    element: <VerifyAccount />,
  },
]
